import { styled } from '@mui/material';

export default styled('div')({ flex: 1 });
